import { render, staticRenderFns } from "./_chat-area-chat.vue?vue&type=template&id=272c43a8&scoped=true"
import script from "./_chat-area-chat.vue?vue&type=script&lang=js"
export * from "./_chat-area-chat.vue?vue&type=script&lang=js"
import style0 from "./_chat-area-chat.vue?vue&type=style&index=0&id=272c43a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272c43a8",
  null
  
)

export default component.exports